import {Component, Input, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {FormatConfigService} from 'app/core/services/format-config.service';
import {CapiLoginService} from '../login/capi-login-service';
import {CapAlertService} from "../exceptions/cap-alert.service";
import {AppConfigService} from "../../services/app-config.service";

@Component({
  selector: 'cap-user-picker',
  templateUrl: './user-picker.component.html'
})

export class UserPickerComponent implements OnInit {
  private languageNames = {
    'en': 'English',
    'de': 'Deutsch',
    'fr': 'Français',
    'it': 'Italiano',
    'rm': 'Rumantsch Grischun',
  };

  isLoginDisabled = false;

  selectedLanguage: string;

  versionInfo: string;

  @Input() languages: string[] = [
    'en', 'de', 'fr'
  ];

  @Input()
  isICP = false;


  constructor(public translateService: TranslateService,
              public loginService: CapiLoginService,
              private capAlertService: CapAlertService,
              private translate: TranslateService,
              private appConfigService: AppConfigService,
              private appFormatConfigService: FormatConfigService) {

  }

  ngOnInit(): void {
    this.selectedLanguage = this.translateService.currentLang;
    this.isLoginDisabled = !this.loginAllowed();
    this.versionInfo = this.translate.instant('version') + " " + this.translate.instant('layouts.page.title') + " " + this.appConfigService.versionNr;
  }

  public languageName(language: string) {
    return this.languageNames[language] || language;
  }

  selectLanguage(language: string): void {
    this.translateService.use(language);
    this.selectedLanguage = language;
  }

  info() {
    this.capAlertService.info(this.versionInfo);
  }

  loginAllowed(): boolean {
    const anonym = <any>this.appFormatConfigService.parameterConfig?.parameters.ZUGELASSENE_BENUTZERKATEGORIEN === 'ANONYM';
    if (this.isICP) {
      return !anonym;
    }
    return true;
  }

  public loginLogout() {
    this.loginService.userLoggedIn ? this.loginService.logout() : this.loginService.login();
  }
}
